import React, { memo } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

const RequestMark = ({ className }) => (
  <SvgIcon
    viewBox="0 0 7 9"
    className={className}
    fill="none"
    width="7"
    height="9"
  >
    <path
      d="M3.03669 5.20727H1.69018V8.21429H0V0H3.04796C4.017 0 4.76444 0.216264 5.29027 0.648793C5.81611 1.08132 6.07902 1.6925 6.07902 2.48234C6.07902 3.04275 5.95695 3.51101 5.71282 3.88712C5.47243 4.25947 5.10623 4.5566 4.6142 4.7785L6.38889 8.1353V8.21429H4.57476L3.03669 5.20727ZM1.69018 3.83634H3.0536C3.47802 3.83634 3.80667 3.72915 4.03954 3.51477C4.27241 3.29662 4.38884 2.99761 4.38884 2.61774C4.38884 2.23034 4.27804 1.92569 4.05644 1.70379C3.83859 1.48188 3.50243 1.37093 3.04796 1.37093H1.69018V3.83634Z"
      fill="white"
    />
  </SvgIcon>
);

export default memo(RequestMark);
